"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_2 = require("@emotion/react");
const Filters_1 = __importDefault(require("./styles/Filters"));
const MovingDot_1 = __importDefault(require("./components/MovingDot"));
const Glow_1 = __importDefault(require("./components/Glow"));
const useNodes_1 = __importDefault(require("./hooks/useNodes"));
const MorphingDot_1 = __importDefault(require("./components/MorphingDot"));
const morph_1 = require("./utils/morph");
const Dialog_1 = __importDefault(require("./components/Dialog"));
const store_1 = require("./store/store");
const ParameterPanel_1 = __importDefault(require("./components/ParameterPanel"));
function App() {
    const { nodes, transferNodes, addNode } = (0, useNodes_1.default)();
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const { parameters } = (0, store_1.useParams)(state => ({
        parameters: state.parameters,
    }));
    function handleKeyDown(e) {
        if (e.key === 'a') {
            addNode();
        }
    }
    (0, react_1.useEffect)(() => {
        const root = document.documentElement;
        let hueNoiseOffset = 0;
        let animationId;
        (function animate() {
            const hueNoise = (0, morph_1.noise)(hueNoiseOffset, hueNoiseOffset);
            const hue = (0, morph_1.map)(hueNoise, -1, 1, 0, 360);
            root.style.setProperty('--startColor', `hsl(${hue}, 100%, 75%)`);
            root.style.setProperty('--stopColor', `hsl(${hue + 60}, 100%, 75%)`);
            hueNoiseOffset += 0.01 / 6;
            animationId = requestAnimationFrame(animate);
        })();
        return () => {
            cancelAnimationFrame(animationId);
        };
    }, []);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ role: "presentation", onKeyDown: handleKeyDown, tabIndex: 0, css: (0, react_2.css) `
          width: 100vw;
          height: 100vh;

          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        ` }, { children: (0, jsx_runtime_1.jsxs)("svg", Object.assign({ viewBox: `0 0 ${window.innerWidth} ${window.innerHeight}` }, { children: [(0, jsx_runtime_1.jsx)(Filters_1.default, {}), (0, jsx_runtime_1.jsxs)("g", Object.assign({ css: (0, react_2.css) `
              filter: url('#goo');
            ` }, { children: [nodes === null || nodes === void 0 ? void 0 : nodes.map(node => ((0, jsx_runtime_1.jsx)(MorphingDot_1.default, { posX: node.x, posY: node.y, size: node.radius * 5 }, node.id))), transferNodes === null || transferNodes === void 0 ? void 0 : transferNodes.map(node => ((0, jsx_runtime_1.jsx)(MovingDot_1.default, { from: node.from, to: node.to, velocity: node.velocity, color: parameters.COLOR_DATA_NODE, radius: parameters.DATA_NODE_RADIUS * 2 }, node.id)))] })), nodes === null || nodes === void 0 ? void 0 : nodes.map(node => ((0, jsx_runtime_1.jsx)(Glow_1.default, { x: node.x, y: node.y, radius: node.radius }, node.id)))] })) })), (0, jsx_runtime_1.jsx)(Dialog_1.default, Object.assign({ isOpen: isOpen, close: () => setIsOpen(false) }, { children: (0, jsx_runtime_1.jsx)(ParameterPanel_1.default, {}) })), (0, jsx_runtime_1.jsx)("button", Object.assign({ type: "button", onClick: () => setIsOpen(true), css: (0, react_2.css) `
          position: fixed;
          bottom: 20px;
          right: 20px;
          color: transparent;

          width: 200px;
          height: 200px;
          background-color: transparent;
          outline: none;
          border: none;

          cursor: pointer;
        ` }, { children: "HELLO" }))] }));
}
exports.default = App;
